export enum ResponseStatusEnum {
    ok,
    error
}



// WEBPACK FOOTER //
// ./src/app/DTO/responseStatusEnum.ts